import { IconButton, Tooltip } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useRef, useState, useEffect, useMemo } from 'react';
import BreadCrumb from '../../../component/BreadCrumb';
import { CODE_GROUP_ID } from '../../../constant/Constant';
import CodeUtil from '../../../util/CodeUtil';
import PopupRef from '../../../component/PopupRef';
import SystemUniversityManagerModal from '../../modal/SystemUniversityManagerModal';
import { modalType } from '../../../util/ModalUtil';
import ModalRef from '../../../component/ModalRef';
import SelectionBox from '../../../component/SelectionBox';
import RegistButtonBox from '../../../component/buttons/RegistButtonBox';
import DeleteIcon from '../../../component/icon/DeleteIcon';
import TableBox from '../../../component/TableBox';
import {
    actionStaffByUniversitySearch,
    actionStaffByUniversityRemove,
} from '../../../module/body/system/SystemUniversityManagerModule';
import { VIEW_SYSTEM_UNIVERSITY_MANAGER } from './../../../constant/ViewConstant';
import SearchButtonBox from '../../../component/buttons/SearchButtonBox';
import { defaultGridData, handleControl, initGrid } from '../../../module/component/TableBoxModule';
import PathUtil from '../../../util/PathUtil';
import { useLocation } from 'react-router-dom';
import qs from 'qs';
import NullCheckUtil from '../../../util/NullCheckUtil';
import FormatUtil from '../../../util/FormatUtil';
import { OpenEditIcon } from '../../../component/icon/GridIcons';
import SessionStorageUtil from '../../../util/SessionStorageUtil';

const ConditionArea = ({ modalRef, popupRef }) => {
    const location = useLocation();
    const queryData = qs.parse(location.search, { ignoreQueryPrefix: true });
    const dispatch = useDispatch();

    const semesterId = SessionStorageUtil.getCurrentSemesterId();
    const [userUniversityCd, setUserUniversityCd] = useState('');
    const userRoleCd = 'STAFF';
    const [params, setParams] = useState({});
    const { gridData } = useSelector((state) => state.tableBoxState);

    useEffect(() => {
        dispatch(
            handleControl({
                columns,
                onRowDoubleClick,
                onChangePageInfo,
                params,
            }),
        );

        queryData.userUniversityCd && setUserUniversityCd(queryData.userUniversityCd);

        onClickSearch({
            userUniversityCd: queryData.userUniversityCd,
            userRoleCd,
            page: NullCheckUtil.isNotNull(queryData.page) ? queryData.page : defaultGridData.page,
            pageSize: NullCheckUtil.isNotNull(queryData.pageSize) ? queryData.pageSize : 100,
        });

        return () => {
            dispatch(initGrid());
        };
    }, []);

    useEffect(() => {
        dispatch(
            handleControl({
                columns,
                onRowDoubleClick,
                onChangePageInfo,
                params,
            }),
        );
    }, [params]);

    const onChangePageInfo = (page, pageSize) => {
        onClickSearch({
            ...params,
            page,
            pageSize,
        });
    };

    const onClickSearch = (params) => {
        setParams(params);
        dispatch(
            actionStaffByUniversitySearch({
                params,
                callback: (result) => {
                    if (result.totalCount == 0) {
                        popupRef.current.openAlert('조회된 결과가 없습니다.');
                    }
                },
            }),
        );
        PathUtil.pushState(location.pathname, params);
    };

    const onRowDoubleClick = (row, params) => {
        modalRef.current.open(
            <SystemUniversityManagerModal
                type={modalType.EDIT}
                modalRef={modalRef}
                row={row}
                callback={() => {
                    onClickSearch(params);
                }}
            />,
            'medium',
        );
    };

    const handleDelete = (row, params) => {
        popupRef.current.openWarning('담당자 ' + row.userNm + '(를)을 삭제하시겠습니까?', () => {
            return function () {
                dispatch(
                    actionStaffByUniversityRemove({
                        params: {
                            userId: row.userId,
                            semesterId,
                        },
                        callback: () => {
                            popupRef.current.openInfo(row.userNm + '(가)이 삭제되었습니다.', () => {
                                return function () {
                                    onClickSearch(params);
                                };
                            });
                        },
                    }),
                );
            };
        });
    };

    const handleAdd = (params) => {
        modalRef.current.open(
            <SystemUniversityManagerModal
                type={modalType.ADD}
                modalRef={modalRef}
                callback={() => {
                    onClickSearch(params);
                }}
            />,
            'medium',
        );
    };

    const onKeyDown = (e) => {
        if (e.key == 'Enter') {
            onClickSearch({
                userUniversityCd,
                userRoleCd,
                page: defaultGridData.page,
                pageSize: gridData.pageSize,
            });
        }
    };

    const columns = useMemo(
        () => [
            {
                field: 'userId',
                headerName: '담당자ID',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            {
                field: 'userUniversityCd',
                headerName: '참여대학',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
                renderCell: (params) =>
                    CodeUtil.getCodeName(CODE_GROUP_ID.USER_UNIVERSITY, params.row.userUniversityCd),
            },
            {
                field: 'userNm',
                headerName: '담당자명',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },

            {
                field: 'email',
                headerName: '담당자 이메일',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            {
                field: 'telNo',
                headerName: '담당자 연락처',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
                renderCell: (params) => FormatUtil.telNoFormatter(params.row.telNo),
            },
            {
                field: 'detail',
                headerName: '기능',
                headerAlign: 'center',
                align: 'center',
                flex: 5,
                disableColumnMenu: true,
                hideSortIcons: true,
                disableExport: true,
                renderCell: (item) => (
                    <>
                        <Tooltip title='수정'>
                            <IconButton onClick={() => onRowDoubleClick(item.row, params)}>
                                <OpenEditIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title='삭제'>
                            <IconButton onClick={(e) => handleDelete(item.row, params)}>
                                <DeleteIcon />
                            </IconButton>
                        </Tooltip>
                    </>
                ),
            },
        ],
        [params],
    );

    return (
        <>
            <div className='con-form-wrap '>
                <div className='board-inner'>
                    <div className='board-row'>
                        <div className='lec-check-box'>
                            <div className='search-condition-box'>
                                <div className='form-box-container'>
                                    <SelectionBox
                                        title='역할'
                                        w140
                                        options={CodeUtil.getCodes(CODE_GROUP_ID.USER_ROLE)}
                                        value={userRoleCd}
                                        disabled={true}
                                        onChange={(e) => setUserRoleCd(e.target.value)}
                                        onKeyDown={(e) => onKeyDown(e)}
                                    />
                                    <SelectionBox
                                        title='대학'
                                        w140
                                        options={CodeUtil.getCodes(CODE_GROUP_ID.MAIN_UNIVERSITY)}
                                        value={userUniversityCd}
                                        onChange={(e) => setUserUniversityCd(e.target.value)}
                                        onKeyDown={(e) => onKeyDown(e)}
                                    />
                                </div>
                            </div>
                            <div className='lec-check-btn'>
                                <SearchButtonBox
                                    title='조회'
                                    onClick={(e) =>
                                        onClickSearch({
                                            userUniversityCd,
                                            userRoleCd,
                                            page: defaultGridData.page,
                                            pageSize: gridData.pageSize,
                                        })
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='con-tb-wrap'>
                <div className='con-tb-title  '>
                    <h3 className='tb-tit-name'>참여대학 담당 교직원 목록</h3>
                    <RegistButtonBox onClick={(e) => handleAdd(params)} />
                </div>
            </div>
        </>
    );
};

const SystemUniversityManagerView = () => {
    const popupRef = useRef(null);
    const modalRef = useRef(null);
    return (
        <section className='container'>
            <div className='container-inner'>
                <div className='con-title-wrap conbg02'>
                    {/* <h2 className='con-title'>참여대학관리</h2> */}
                    <h2 className='con-title'>{VIEW_SYSTEM_UNIVERSITY_MANAGER.title}</h2>
                    <p className='con-title-p'>{VIEW_SYSTEM_UNIVERSITY_MANAGER.subTitle}</p>
                </div>
                <div className='sub-nav-wrap'>
                    <BreadCrumb />
                </div>
                <ConditionArea modalRef={modalRef} popupRef={popupRef} />
                <TableBox isSupportedWide={false} />
            </div>
            <PopupRef ref={popupRef} />
            <ModalRef ref={modalRef} />
        </section>
    );
};

export default SystemUniversityManagerView;
